import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { DataService_MultiStationModifyVisitors } from "../shared/data.service";
import { VisitorModifyRequest } from "../shared/VisitorModifyRequest";
import * as moment from "moment";

@Component({
	selector: "app-ms-visitor-edit",
	templateUrl: "./ms-visitor-edit.component.html",
	styleUrls: ["./ms-visitor-edit.component.css"],
})
export class MsVisitorEditComponent implements OnInit {
	constructor(
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private visitorService: DataService_MultiStationModifyVisitors,
		private dialogConfig: DynamicDialogConfig
	) {}

	ngOnInit(): void {
		this.IsBlocked = this.dialogConfig.data.IsBlocked;
		this.PersonID = this.dialogConfig.data.PersonID;

		this.loadData();
	}

	/////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////

	IsBlocked: boolean = false;
	PersonID: number = -1;

	FirstName: string = "";
	MiddleName: string = "";
	LastName: string = "";
	DOB: Date = new Date();
	Gender: string = "";
	SelectedRace: any;
	lstRace: any = [];

	SelectedEthnicity: any;
	lstEthnicity: any = [];

	SelectedVisitorType: any;
	lstVisitorType: any = [];

	SelectedVisitorStatus: any;
	lstVisitorStatus: any = [];

	LicenseNbr: string = "";
	Address: string = "";
	City: string = "";
	State: string = "";
	Zip: string = "";
	PhoneNumber: string = "";
	Email: string = "";
	Notes: string = "";

	PhotoB64: string = "";

	loading: boolean = false;

	errorMessage: any = "";

	/////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////

	loadData() {
		this.loading = true;

		var result = this.visitorService.VisitorEditInfoSelect(this.PersonID);
		result.subscribe(
			(response: any) => {
				this.FirstName = response.FirstName == undefined ? "" : response.FirstName;
				this.MiddleName = response.MiddleName == undefined ? "" : response.MiddleName;
				this.LastName = response.LastName == undefined ? "" : response.LastName;

				if (response.DOB != undefined) {
					this.DOB = new Date(response.DOB);
				}

				this.Gender = response.Gender == undefined ? "" : response.Gender;
				this.Address = response.Address == undefined ? "" : response.Address;
				this.City = response.City == undefined ? "" : response.City;
				this.State = response.State == undefined ? "" : response.State;
				this.Zip = response.Zip == undefined ? "" : response.Zip;
				this.LicenseNbr = response.LicenseNbr == undefined ? "" : response.LicenseNbr;
				this.PhoneNumber = response.PhoneNumber == undefined ? "" : response.PhoneNumber;
				this.Email = response.Email == undefined ? "" : response.Email;
				this.Notes = response.Notes == undefined ? "" : response.Notes;
				this.PhotoB64 = response.PhotoB64 == undefined ? "" : response.PhotoB64;

				if (response.lstVisitorType != undefined) {
					this.lstVisitorType = response.lstVisitorType;
					this.SelectedVisitorType = this.lstVisitorType[0];

					if (response.VisitorTypeID != undefined) {
						for (var z = 0; z < this.lstVisitorType.length; z++) {
							var next = this.lstVisitorType[z];

							if (next.VisitorTypeID == response.VisitorTypeID) {
								this.SelectedVisitorType = next;
								break;
							}
						}
					}
				}

				if (response.lstVisitorStatus != undefined) {
					this.lstVisitorStatus = response.lstVisitorStatus;
					this.SelectedVisitorStatus = this.lstVisitorStatus[0];

					if (this.IsBlocked == true) {
						for (var z = 0; z < this.lstVisitorStatus.length; z++) {
							var next = this.lstVisitorStatus[z];

							if (next.AllowAdmittance == false) {
								this.SelectedVisitorStatus = next;
								break;
							}
						}
					}

					if (response.VisitorStatusID != undefined) {
						for (var z = 0; z < this.lstVisitorStatus.length; z++) {
							var next = this.lstVisitorStatus[z];

							if (next.VisitorStatusID == response.VisitorStatusID) {
								this.SelectedVisitorStatus = next;
								break;
							}
						}
					}
				}

				if (response.lstRace != undefined) {
					this.lstRace = response.lstRace;

					this.lstRace.unshift({
						RaceID: -1,
						RaceDesc: "Not Provided",
					});

					this.SelectedRace = this.lstRace[0];

					if (response.RaceID != undefined) {
						for (var z = 0; z < this.lstRace.length; z++) {
							var next = this.lstRace[z];

							if (next.RaceID == response.RaceID) {
								this.SelectedRace = next;
								break;
							}
						}
					}
				}

				if (response.lstEthnicity != undefined) {
					this.lstEthnicity = response.lstEthnicity;
					this.SelectedEthnicity = this.lstEthnicity[0];

					if (response.EthnicityID != undefined) {
						for (var z = 0; z < this.lstEthnicity.length; z++) {
							var next = this.lstEthnicity[z];

							if (next.EthnicityID == response.EthnicityID) {
								this.SelectedEthnicity = next;
								break;
							}
						}
					}
				}

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////
	onUpdate() {
		this.errorMessage = "";

		//
		// Error Handling
		//

		//Required Fields
		if (this.FirstName == undefined || String(this.FirstName).trim() == "") {
			this.errorMessage = "Enter a First Name";
			return;
		}
		if (this.LastName == undefined || String(this.LastName).trim() == "") {
			this.errorMessage = "Enter a Last Name";
			return;
		}
		// if(this.State == undefined || String(this.State).trim() == ""){
		//   this.errorMessage = "Enter what State the visitor's driver's license is from";
		//   return;
		// }
		// if(this.LicenseNbr == undefined || String(this.LicenseNbr).trim() == ""){
		//   this.errorMessage = "Enter the visitor's driver's license number";
		//   return;
		// }

		var fsDOB: string = moment(this.DOB).format("MM/DD/YYYY");

		if (String(fsDOB).toLowerCase().indexOf("invalid") != -1) {
			fsDOB = "";
			// return;
		}

		this.loading = true;

		var parms: VisitorModifyRequest = {
			PersonID: this.PersonID,
			FirstName: this.FirstName,
			MiddleName: this.MiddleName,
			LastName: this.LastName,
			DOB: fsDOB,
			VisitorTypeID: this.SelectedVisitorType.VisitorTypeID,
			VisitorStatusID: this.SelectedVisitorStatus.VisitorStatusID,
			Gender: this.Gender,
			RaceID: this.SelectedRace.RaceID,
			EthnicityID: this.SelectedEthnicity.EthnicityID,
			Address: this.Address,
			City: this.City,
			State: this.State,
			Zip: this.Zip,
			LicenseNbr: this.LicenseNbr,
			PhoneNbr: this.PhoneNumber,
			Email: this.Email,
			Notes: this.Notes,
			PhotoB64: this.PhotoB64,
		};

		var result = this.visitorService.VisitorUpdate(parms);
		result.subscribe(
			(response: any) => {
				this.loading = false;

				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "editvisitor",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Visitor was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "editvisitor",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the visitor: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	onSelectFile() {
		document.getElementById("SelectedImage").click();
	}

	onSelectedImageChange(val) {
		if (val.target.files != undefined && val.target.files[0] != undefined) {
			var fr = new FileReader();

			fr.onload = (e: any) => {
				this.ResizeImageAndUpload(val.target.files[0], e.target.result, 640, this);
			};

			fr.readAsDataURL(val.target.files[0]);
		}
	}

	ResizeImageAndUpload(imgfile: any, imgfiledata: any, MAX_SIZE: any, _this: this) {
		// Create work image for resizing
		let img = document.createElement("img");

		img.onerror = function () {
			console.log("ERROR: Invalid Image! -> ", imgfile.name);
		};

		img.onload = function () {
			let width = img.width;
			let height = img.height;

			if (width >= height) {
				// Landscape
				height = Math.round(img.height * (MAX_SIZE / img.width));
				width = MAX_SIZE;
			} else {
				// Portrait
				width = Math.round(img.width * (MAX_SIZE / img.height));
				height = MAX_SIZE;
			}

			let canvas = document.createElement("canvas");

			canvas.width = width;
			canvas.height = height;

			let ctx = canvas.getContext("2d");

			ctx.drawImage(img, 0, 0, width, height);

			_this.PhotoB64 = canvas.toDataURL("image/jpeg");
			// _this.isPersonImageChanged = true;
		};

		// Load The Image Data
		img.src = imgfiledata;
	}

	onClose() {
		this.ref.close(0);
	}
	/////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////

	IsLoading() {
		return this.loading == true;
	}

	NoValue(val) {
		if (val == undefined) {
			return true;
		} else if (String(val).trim() == "") {
			return true;
		} else {
			return false;
		}
	}

	/////////////////////////////////////////////////////////////
}
